import React, { useState } from 'react';
import { Button } from '../components/Button';
import { isValidEmail } from '../utils/mailchimp';
type EmailGateProps = {
  onSubmit: (email: string) => void;
  onBack: () => void;
};
export function EmailGate({
  onSubmit,
  onBack
}: EmailGateProps) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    onSubmit(email.trim());
  };
  return <div className="mx-auto w-full max-w-md px-6 pb-24 pt-16 text-center" data-id="element-68" data-mp="1vejm9vensnpo">
      <p className="text-[10px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-69" data-mp="1vcgouqb6fsax">Last step</p>
      <h1 className="mt-3 font-display text-[26px] font-bold leading-tight text-ink sm:text-[32px]" data-id="element-70" data-mp="2074hn1d7r8vb">
        Your profile is ready
      </h1>
      <p className="mt-3 text-[15px] font-light leading-[1.75] text-ink-light" data-id="element-71" data-mp="17o7bmcs14cve">
        Enter your email and your complete results appear on the next screen.
      </p>

      <form onSubmit={handleSubmit} className="mt-7 rounded-xl border border-border bg-cream-light p-6 text-left" data-id="element-72" data-mp="3hcodld5gl047">
        <label htmlFor="email" className="block text-[13px] font-medium text-ink-light" data-id="element-73" data-mp="37ksbzs45yrv8">
          Email address
        </label>
        <input id="email" type="email" name="email" autoComplete="email" inputMode="email" required value={email} onChange={event => setEmail(event.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? 'email-error' : undefined} className="mt-1.5 w-full rounded-md border border-border bg-cream px-3.5 py-2.5 text-[15px] text-ink outline-none transition-colors duration-150 ease-out focus:border-teal" placeholder="you@example.com" data-id="element-74" data-mp="32kxmnt01eaca" />

        {error && <p id="email-error" role="alert" className="mt-2 text-[13px] text-[#b94040]" data-id="element-75" data-mp="hx1euwduzas4">
            {error}
          </p>}

        <Button type="submit" fullWidth className="mt-5" data-id="element-76" data-mp="2c9viq0wtcide">
          Show My Results →
        </Button>

        <p className="mt-3 text-center text-xs leading-relaxed text-ink-muted" data-id="element-77" data-mp="2h4rijn8aka12">
          Your email joins Dr. Conkright's newsletter. You can opt out at any time, and your address
          is never shown on your results or your shareable card.
        </p>
      </form>

      <button type="button" onClick={onBack} className="mt-5 text-[13px] text-ink-muted underline underline-offset-4 transition-colors duration-150 ease-out hover:text-ink-light" data-id="element-78" data-mp="2v2zebrtld5an">
        ← Back to the last questions
      </button>
    </div>;
}